import { useState } from "react";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import { useAuth } from "../../context/AuthContext";
import Toast from "../../helpers/Toast";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { CompleteAssistanceExecutionDTO } from "../../models/AssistanceExecution/CompleteAssistanceExecutionDTO";
import { CreateAssistanceExecutionDTO } from "../../models/AssistanceExecution/CreateAssistanceExecutionDTO";
import { AssistanceService } from "../../services/AssistanceService";

type ExecutionButtonsType = {
    assistance: AssistanceDTO;
    setAssistance: React.Dispatch<React.SetStateAction<AssistanceDTO>>;
    reloadExecutions: () => void;

    onFetchExecutionsData: () => void;
}

export function ExecutionButtons({ assistance, setAssistance, reloadExecutions, ...props }: ExecutionButtonsType) {

    //Pagina
    const intl = useIntl();
    const [isLoadingExecutionButtons, setIsLoadingExecutionButtons] = useState<boolean>(false);
    const assistanceService = new AssistanceService();
    const { currentUser } = useAuth();

    const startExecution = async () => {
        setIsLoadingExecutionButtons(true);

        if (currentUser?.id == null) {
            Toast.Show("error", "Utilizador não tem sessão iniciada");
            return;
        }
        const executionInfo: CreateAssistanceExecutionDTO = {
            executionStart: new Date(),
            assistanceId: assistance.id,
            technicianId: currentUser.id
        }
        var response = await assistanceService.AddExecution(executionInfo);

        setIsLoadingExecutionButtons(false);

        if (response.success !== true || response.obj == null) {
            Toast.Show("error", response.message);
            return;
        }

        setAssistance({
            ...assistance,
            canCompleteExecution: !assistance.canCompleteExecution,
            canStartExecution: !assistance.canStartExecution,
            openExecutionIds: response.obj
        })
        props.onFetchExecutionsData();
        Toast.Show("success", "Execução iniciada");
    };

    const completeExecution = async () => {
        setIsLoadingExecutionButtons(true);

        if (currentUser?.id == null) {
            Toast.Show("error", "Utilizador não tem sessão iniciada");
            return;
        }

        const executionInfo: CompleteAssistanceExecutionDTO = {
            executionEnd: new Date(),
            assistanceExecutionIds: assistance.openExecutionIds ?? 0,
            technicianId: currentUser.id,
        }

        var response = await assistanceService.CompleteExecution(executionInfo);

        setIsLoadingExecutionButtons(false);
        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }

        setAssistance({ ...assistance, canCompleteExecution: !assistance.canCompleteExecution, canStartExecution: !assistance.canStartExecution })
        props.onFetchExecutionsData();
        Toast.Show("success", "Execução completada");
    };

    return (
        <Row style={{ margin: "15px 2px 10px 0px" }}>
            <Col xl={3} lg={5} md={6} sm={6} xs={6}>
                <ButtonComponent
                    disabled={assistance.canCompleteExecution}
                    loading={isLoadingExecutionButtons}
                    text={intl.formatMessage({ id: "Screens.Assistances.ExecutionButtons.StartExecution" })}
                    onClick={startExecution}
                    style={{
                        width: "100%",
                        height: "65px",
                        fontSize: "var(--header-font-size)",
                        whiteSpace: "pre-wrap"
                    }} />
            </Col>

            <Col xl={3} lg={5} md={6} sm={6} xs={6} className={"offset-lg-1 offset-xl-0"}>
                <ButtonComponent
                    disabled={assistance.canStartExecution}
                    loading={isLoadingExecutionButtons}
                    text={intl.formatMessage({ id: "Screens.Assistances.ExecutionButtons.CompleteExecution" })}
                    onClick={completeExecution}
                    style={{
                        width: "100%",
                        height: "65px",
                        fontSize: "var(--header-font-size)",
                        whiteSpace: "pre-wrap"
                    }} />
            </Col>
        </Row>
    )
}

